import { zodResolver } from "@hookform/resolvers/zod";
import { useMemo } from "react";
import {
  useForm,
  Control,
  UseFormHandleSubmit,
  UseFormReturn,
  UseFormGetValues,
} from "react-hook-form";
import { object, string } from "zod";

import { useT } from "src/internationalization";

export type DecisionFormControl = {
  control: Control<DecisionFormData>;
  submit: UseFormHandleSubmit<DecisionFormData>;
  getValues: UseFormGetValues<DecisionFormData>;
  hasError: boolean;
  methods: UseFormReturn<DecisionFormData>;
};

export type DecisionFormData = {
  decision: string | null;
};

export const useDecisionForm = (): DecisionFormControl => {
  const t = useT();
  const validationSchema = useMemo(
    () =>
      object({
        decision: string().min(1, t("general.form.field.required")),
      }),
    [t]
  );

  const methods = useForm<DecisionFormData>({
    resolver: zodResolver(validationSchema),
    defaultValues: {
      decision: null,
    },
    mode: "onSubmit",
  });

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitted },
  } = methods;

  return {
    control,
    submit: handleSubmit,
    hasError: isSubmitted ? !isValid : false,
    methods,
    getValues: methods.getValues,
  };
};
